import { THIRTY_TWO_CARDS_BET_TYPES } from './betTypes/32cards';
import { ANDAR_BAHAR_BET_TYPES, OTT_ANDAR_BAHAR_BET_TYPES } from './betTypes/andarbahar';
import {
  BACCARAT_BET_TYPES,
  BACCARAT_MAIN_BET_TYPES,
  BACCARAT_SIDE_BET_TYPES,
  BACCARAT_WINNING_TOTAL_TYPES,
  BACCARAT_NATURAL_BETS_TYPES,
} from './betTypes/baccarat';
import { BET_ON_TEEN_PATTI_BET_TYPES } from './betTypes/betonteenpatti';
import { CASINO_HOLDEM_BET_TYPES } from './betTypes/casinoholdem';
import { LUCKY_7_BET_TYPES } from './betTypes/lucky7';
import { MARBLE_RACE_BET_TYPES } from './betTypes/marblerace';
import { MATKA_BET_TYPES } from './betTypes/matka';
import { ONE_DAY_TEEN_PATTI_BET_TYPES } from './betTypes/onedayteenpatti';
import { ROULETTE_BET_TYPES } from './betTypes/roulette';
import { RUSSIAN_POKER_BET_TYPES } from './betTypes/russianpoker';
import { SICBO_BET_TYPES } from './betTypes/sicbo';
import { THREE_CARD_POKER_BET_TYPES } from './betTypes/threecardpoker';
import * as ULTIMATE_DICE_BET_TYPES from './betTypes/ultimatedice';
import * as XOC_DIA_BET_TYPES from './betTypes/xocdia';
import * as COLORS from './colors';
import * as ERRORS from './errors';
import {
  BACCARAT_DRAGON_BONUS_ID,
  BACCARAT_ID,
  BACCARAT_KO_ID,
  BACCARAT_NO_COMMISSION_ID,
  BACCARAT_QUEENCO_ID,
  BACCARAT_SUPER_SIX_ID,
  EZ_BACCARAT_ID,
} from './gameIds';
import * as STATUS from './status';

export * from './amount';
export * from './breakpoints';
export * from './currencySymbols';
export * from './device';
export * from './gameEngine';
export * from './gameIds';
export * from './navigationMethods';
export * from './sizes';
export * from './urls';
export * from './gameSocketMessages';
export * from './media';
export * from './video';
export * from './roulette';
export * from './strings';
export * from './postMessage';
export * from './legacy';
export * from './widgets';
export * from './bonus';

export {
  ROULETTE_BET_TYPES,
  BACCARAT_BET_TYPES,
  BACCARAT_MAIN_BET_TYPES,
  BACCARAT_SIDE_BET_TYPES,
  BACCARAT_WINNING_TOTAL_TYPES,
  BACCARAT_NATURAL_BETS_TYPES,
  ANDAR_BAHAR_BET_TYPES,
  OTT_ANDAR_BAHAR_BET_TYPES,
  THREE_CARD_POKER_BET_TYPES,
  CASINO_HOLDEM_BET_TYPES,
  BET_ON_TEEN_PATTI_BET_TYPES,
  ONE_DAY_TEEN_PATTI_BET_TYPES,
  MARBLE_RACE_BET_TYPES,
  LUCKY_7_BET_TYPES,
  MATKA_BET_TYPES,
  THIRTY_TWO_CARDS_BET_TYPES,
  RUSSIAN_POKER_BET_TYPES,
  SICBO_BET_TYPES,
  ULTIMATE_DICE_BET_TYPES,
  XOC_DIA_BET_TYPES,
  COLORS,
  STATUS,
  ERRORS,
};

export * from './colors/betonteenpatti';
export { default as THIRTY_TWO_CARDS_COLORS } from './colors/32cards';
export { default as AB_COLORS } from './colors/andarbahar';
export { default as BAC_COLORS, ROAD_COLORS_V2, ROADS_LOBBY_COLORS_V2, EZ_BOARD_COLORS } from './colors/baccarat';

export * from './V2/sizes';
export const BACK_CARD_NAME = 'ww';

export * from './testing';

/** local storage key telling the maximum number of times
 * the welcome message/tutorial popup should be displayed
 */
export const MAX_WELCOME_DISPLAYS = 'maxWelcomeDisplays';

/** local storage key telling for how many times
 * the welcome message/tutorial popup was displayed
 */
export const COUNTER_WELCOME_DISPLAYS = 'counterWelcomeDisplays';

export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const DIALOG_CLOSE_TIMER_IN_MILLISECONDS = 30000;

export const REDESIGNED_BACCARAT_GAME_IDS = [
  BACCARAT_ID,
  BACCARAT_KO_ID,
  BACCARAT_NO_COMMISSION_ID,
  BACCARAT_DRAGON_BONUS_ID,
  BACCARAT_QUEENCO_ID,
  BACCARAT_SUPER_SIX_ID,
  EZ_BACCARAT_ID,
];
